import firebase from 'firebase/app'
import 'firebase/functions'

export const qilinPreviewEnabled = process.env.NODE_ENV === 'development' && process.env.VUE_APP_QILIN_PREVIEW === '1'
let qilinPreviewPromise = null

function qilinFunctions () {
  return firebase.app().functions('asia-east2')
}

async function callQilinPreview (method, ...args) {
  if (!qilinPreviewPromise) {
    qilinPreviewPromise = import(/* webpackChunkName: "fun-buddy-preview" */ './qilinPreviewData')
  }
  const previewModule = await qilinPreviewPromise
  return previewModule.default[method](...args)
}

function currentUserkey () {
  try {
    const user = JSON.parse(localStorage.getItem('userData') || '{}')
    return user.key || ''
  } catch (error) {
    return ''
  }
}

async function callQilin (name, payload = {}) {
  const userkey = currentUserkey()
  if (!userkey) throw new Error('ไม่พบข้อมูลผู้ใช้ กรุณาเข้าสู่ระบบอีกครั้ง')
  const callable = qilinFunctions().httpsCallable(name)
  const response = await callable(Object.assign({ userkey }, payload))
  return response.data
}

export function qilinErrorMessage (error) {
  const code = String(error && error.code ? error.code : '')
  const message = String(error && error.message ? error.message : '')
  if (/feature is not enabled/i.test(message)) return 'ระบบ FUN Buddy ยังไม่เปิดให้บัญชีนี้ใช้งาน'
  if (code.includes('already-exists')) return 'รับสิทธิ์นี้ไปแล้ว กรุณาลองใหม่พรุ่งนี้'
  if (code.includes('unauthenticated')) return 'กรุณาเข้าสู่ระบบอีกครั้ง'
  if (code.includes('permission-denied')) return 'ระบบ FUN Buddy ยังไม่เปิดให้บัญชีนี้ใช้งาน'
  if (code.includes('failed-precondition') && /coin/i.test(message)) return 'เหรียญไม่เพียงพอสำหรับเปลี่ยนชื่อ'
  if (code.includes('failed-precondition')) return 'ยังทำเงื่อนไขไม่ครบ กรุณาตรวจสอบอีกครั้ง'
  if (code.includes('unavailable')) return 'เชื่อมต่อไม่สำเร็จ กรุณาลองอีกครั้ง'
  return 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
}

export default {
  // Deposit and reward summaries must always come from the backend.
  getHomeStatus: () => qilinPreviewEnabled ? callQilinPreview('getHomeStatus') : callQilin('getQilinHomeStatus'),
  getPetStatus: () => qilinPreviewEnabled ? callQilinPreview('getPetStatus') : callQilin('getQilinPetStatus'),
  play: () => qilinPreviewEnabled ? callQilinPreview('play') : callQilin('playWithQilinPet'),
  updateProfile: payload => qilinPreviewEnabled ? callQilinPreview('updateProfile', payload) : callQilin('updateQilinPetProfile', payload),
  getCheckinStatus: () => qilinPreviewEnabled ? callQilinPreview('getCheckinStatus') : callQilin('getQilinCheckinStatus'),
  claimCheckin: () => qilinPreviewEnabled ? callQilinPreview('claimCheckin') : callQilin('claimQilinDailyCheckin'),
  getMissionsStatus: () => qilinPreviewEnabled ? callQilinPreview('getMissionsStatus') : callQilin('getQilinMissionsStatus'),
  claimMission: missionId => qilinPreviewEnabled ? callQilinPreview('claimMission', missionId) : callQilin('claimQilinMissionReward', { missionId })
}
